export const pusherTimeoutForTesting = {
  timeoutMs: undefined,
  setTimeoutMs: function setTimeout(timeoutMs) {
    this.timeoutMs = timeoutMs;
  },
  getTimeoutMs: function getTimeout() {
    return this.timeoutMs;
  },
};
